import { Type } from 'class-transformer';

import { IPagination } from './utils';

export class ICity {
  code: string;
  countryId: string | number;
  id: string | number;
  name: string;
}

export class ICityListResponse extends IPagination {
  @Type(() => ICity)
  results: ICity[];
}
export class ICityResponse {
  @Type(() => ICity)
  result: ICity;
}

export class ISubCity {
  cityId: string | string;
  code: string;
  id: string | number;
  name: string;
  route: number;
  night: number;
}

export class ISubCityListResponse extends IPagination {
  @Type(() => ISubCity)
  results: ISubCity[];
}

export class ISubCityResponse {
  @Type(() => ISubCity)
  result: ISubCity;
}
